import React from "react";
import _ from "lodash";
import userImg from "../../../assets/images/bingo/user-img.png";
import pauseBtn from "../../../assets/images/bingo/pause-btn.png";
import playBtn from "../../../assets/images/bingo/play.png";
import { Col, Container, Row } from "reactstrap";

const BadBingo = ({
  onTimesUp,
  timedGame,
  current_number,
  badBingoUsers,
  lastNumber,
  gamePaused,
  toggleGamePaused,
  countdown,
  currentAlphabet,
  paramsReducerr,
}) => {
  const parameters = _.get(paramsReducerr, "5_badbingo");
  let customClass = "last-num-circle-red";

  function nextBall() {
    onTimesUp();
    onTimesUp();
  }
  function coustomClass(curr_number) {
    if (curr_number < 16) {
      customClass = "last-num-circle-red";
    } else if (curr_number >= 16 && curr_number <= 30) {
      customClass = "last-num-circle-blue";
    } else if (curr_number >= 31 && curr_number <= 45) {
      customClass = "last-num-circle-purple";
    } else if (curr_number >= 46 && curr_number <= 60) {
      customClass = "last-num-circle-orange";
    } else {
      customClass = "last-num-circle-green";
    }
    return customClass;
  }
  return (
    <>
      <Container>
        <Row>
          <Col xl={8} lg={8}>
            <div className="bad-bingo-modal">
              <div className="bad-bingo-dialog">
                <div className="bad-bingo-content">
                  <h2 className="bad-text">{parameters?.label}</h2>
                  <div className="player">
                    {/* <div className="player-list">
                      {badBingoUsers &&
                        badBingoUsers.length > 0 &&
                        badBingoUsers.map((user) => (
                          <div className="player-img">
                            <img src={user.profile_image} alt="player" />
                            <p className="player-name">{user.display_name}</p>
                          </div>
                      ))}
                    </div> */}
                    {badBingoUsers &&
                      badBingoUsers.length > 0 &&
                      badBingoUsers.map((user) => (
                        <div className="player-list">
                          <div className="player-img">
                            <img src={user.profile_image} alt="player" />
                            <p className="player-name">{user.display_name}</p>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="reasons">
                    <h3>REASONS:</h3>
                    <ul>
                      <li>{parameters?.reasons_list?.[0]}</li>
                      <li>{parameters?.reasons_list?.[1]}</li>
                    </ul>
                  </div>
                  <div className="bad-bingo-timer">
                    {timedGame ? (
                      <div className="timer">
                        <h4>{parameters?.timer_label}</h4>
                        <h5 className="time">{countdown}</h5>
                        <button onClick={toggleGamePaused} className="pause-btn">
                          {gamePaused ? (
                            <img className="play-btn-badBingo" src={playBtn} alt="" />
                          ) : (
                            <img src={pauseBtn} alt="pause" />
                          )}
                          {/* <img src={pauseBtn} alt="pause" /> */}
                        </button>
                      </div>
                    ) : (
                      <div className="timer">
                        <div className="text-center mt-4 mb-2">
                          <button onClick={nextBall} className="play-again-btn">
                            {parameters?.ball_button}
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="last-number">
                      <h4 className="last-num">{parameters?.last_label}</h4>
                      <div className={coustomClass(current_number)}>
                        <p className="alpha">{currentAlphabet(current_number)}</p>
                        <p className="num">{current_number}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default BadBingo;
